// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "锅炉与锅炉房设计",
      "tec": "申宇杨利",
      "week": "5-7,11-16周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "热力发电厂",
      "tec": "王强",
      "week": "1-7,11-17周",
      "add": "教学楼D座424能动AISEC"
    },
    {
      "sub": "燃气轮机与联合循环",
      "tec": "姜鑫高宇",
      "week": "1,3-7,11-14周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "1-6周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "集控运行",
      "tec": "傅玉栋",
      "week": "1-7,11-13周",
      "add": "教学楼D座424能动AISEC"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "1-6周",
      "add": "教学楼D座513能动AISEC"
    },
    [
      {
        "sub": "燃气轮机与联合循环",
        "tec": "姜鑫高宇",
        "week": "1,3,5,7,11,13周",
        "add": "教学楼D座514能动AISEC"
      },
      {
        "sub": "热力发电厂",
        "tec": "王强",
        "week": "2,4,6,12,14,16周",
        "add": "教学楼D座424能动AISEC"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "集控运行",
      "tec": "傅玉栋",
      "week": "1-7,11-13周",
      "add": "教学楼D座424能动AISEC"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
